import { getAt } from './path'
import type { FieldId } from './result'

export type Cleaner = (value: unknown) => string
export type Cleaners = Record<FieldId, Cleaner>

const defaultClean = (v: unknown): string => (v == null ? '' : String(v).trim().toLowerCase())

export type Diff = { field: FieldId; expected: string }

export function compare(
  a: unknown,
  b: unknown,
  paths: FieldId[],
  cleaners: Cleaners = {},
): Diff[] {
  const diffs: Diff[] = []
  for (const path of paths) {
    const clean = cleaners[path] ?? defaultClean
    if (clean(getAt(a, path)) !== clean(getAt(b, path))) {
      const ref = getAt(b, path)
      diffs.push({ field: path, expected: ref == null ? '' : String(ref) })
    }
  }
  return diffs
}
